import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, reset, SubmissionError } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import {
  requestFetchDiagnoses,
  requestSearchDiagnoses,
} from 'redux/modules/diagnoses';
import { accountLoginFail } from 'redux/modules/account';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

const styles = () => ({
  suggestion: {
    height: 'auto',
    whiteSpace: 'normal',
  },
});

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues);

    delete normalizedValues['Selected Name'];

    return normalizedValues;
  };
  if (values.ID !== null) {
    dispatch(reset(props.form));
    return normalizeValues(values);
  }
  throw new SubmissionError({ ID: 'Field is required' });
}

function onChange(values, dispatch, props) {
  if (props.variant === 'default' && values.ID !== null) {
    props.submit(props.form);
  }
}

const DiagnosesAddForm = ({
  handleSubmit,
  className,
  disabled,
  change,
  variant,
  actions,
  formValues,
  account,
  classes,
  diagnosis,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
    role="presentation"
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
      }
    }}
  >
    <Grid container justify="center" spacing={24}>
      <Grid item xs={12}>
        <Field
          id="Name"
          name="Name"
          component={AutosuggestField}
          fullWidth
          disabled={disabled}
          renderSuggestionContent={suggestion => (
            <Grid container spacing={8}>
              <Grid item xs={2}>
                {suggestion['DX Code']}
              </Grid>
              <Grid item xs={10}>
                {suggestion['Long Description']}
              </Grid>
            </Grid>
          )}
          renderInputContent={suggestion => `${suggestion['DX Code']} ${suggestion['Long Description']}`}
          onSuggestionSelected={(suggestion) => {
            change('ID', suggestion.ID);
            change('DX Code', suggestion['DX Code']);
            if (variant === 'dialog') {
              return `${suggestion['DX Code']} ${suggestion['Long Description']}`;
            }
            return '';
          }}
          fetchSuggestions={({ value, limit, offset }) => {
            if (value.length === 0 && diagnosis.length === 0) {
              return requestFetchDiagnoses({
                limit,
                offset,
              }).then(res => res.data,
                (error) => {
                  if (variant === 'dialog' && error.data.error === 'Access Error') {
                    actions.saveRecoverOrder({
                      [account.ID]: {
                        ...formValues,
                        timestamp: new Date().getTime(),
                      },
                    });
                    actions.accountLoginFail();
                  }
                  return error;
                });
            }
            let name;
            let operation;
            if (value.length >= 2 && /^[A-Z]+\d/i.test(value)) {
              name = 'DX Code';
              operation = 'startswith';
            } else {
              name = 'Long Description';
              operation = 'contains';
            }
            return requestSearchDiagnoses({
              filters: [
                ...value.length > 0 ? [{
                  name,
                  operation,
                  val: value,
                  case_sensitivity: false,
                }] : [],
                ...diagnosis.length > 0 ? [{
                  name: 'ID',
                  operation: 'nin',
                  val: diagnosis.map(item => item.ID),
                }] : [],
              ],
              limit,
              offset,
            }).then(res => res.data,
              (error) => {
                if (variant === 'dialog' && error.data.error === 'Access Error') {
                  actions.saveRecoverOrder({
                    [account.ID]: {
                      ...formValues,
                      timestamp: new Date().getTime(),
                    },
                  });
                  actions.accountLoginFail();
                }
                return error;
              });
          }}
          suggestionClassName={classes.suggestion}
          onlyConfirmedSelection
        />
      </Grid>
    </Grid>
  </form>
);

DiagnosesAddForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'dialog']),
  classes: PropTypes.shape({
    suggestion: PropTypes.string.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
    saveRecoverOrder: PropTypes.func.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
};

DiagnosesAddForm.defaultProps = {
  className: '',
  disabled: false,
  variant: 'default',
  formValues: {},
  diagnosis: [],
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail, saveRecoverOrder }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'patientDiagnosesAdd',
  onSubmit,
  onChange,
  initialValues: {
    ID: null,
  },
})(withStyles(styles)(DiagnosesAddForm)));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Diagnoses/DiagnosesAddForm.js